export const displayListSuccessMessage = () => {
    window.displayListSuccessMessage();  
}   